import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 1C12.299 1 12.5673 1.13122 12.7506 1.33921L16.7095 5.29244C17.1 5.68297 17.1001 6.32193 16.7096 6.71245C16.319 7.10298 15.6801 7.10297 15.2896 6.71244L13 4.41957V11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V4.41951L8.71039 6.71242C8.31987 7.10295 7.68091 7.103 7.29039 6.71247C6.89986 6.32195 6.89987 5.683 7.29039 5.29247L11.2498 1.33872C11.4331 1.13101 11.7012 1 12 1Z M1 10C1 8.89543 1.89543 8 3 8H7C7.55228 8 8 8.44771 8 9C8 9.55229 7.55228 10 7 10H3V21H21V10H17C16.4477 10 16 9.55229 16 9C16 8.44771 16.4477 8 17 8H21C22.1046 8 23 8.89543 23 10V21C23 22.1046 22.1046 23 21 23H3C1.89543 23 1 22.1046 1 21V10Z M7 14C6.44772 14 6 14.4477 6 15C6 15.5523 6.44771 16 7 16H17C17.5523 16 18 15.5523 18 15C18 14.4477 17.5523 14 17 14H7Z"
  }));
});
var PaymentCharge = AbstractIcon.withComponent(Icon);
PaymentCharge.displayName = 'PaymentCharge';
export default PaymentCharge;